import { useLanguageStore } from "~/store/languageStore.js";
import { useAPI } from "~/uses/useMyFetch.js";

export const PAYMENT_TYPE = {
  CASH: "cash",
  COUNTERPARTY: "counterparty",
  LIQPAY_MERCHANT: "liqPayMerchant",
  PRIVATBANK_MERCHANT: "privatBankMerchant",
  MONOBANK_MERCHANT: "monobankMerchant",
  MONOBANK_PAYPARTS: "monobankPayParts",
};

/*
state = "SUCCESS"
subState = "WAITING_FOR_STORE_CONFIRM"
для payPats от monobank
 */
export const isOrderPaid = (order) => {
  return order.payment.statuses?.some(
    (status) =>
      status.isPaid ??
      ("SUCCESS" === status.state ||
        "WAITING_FOR_STORE_CONFIRM" === status.subState),
  );
};

export const getPaymentMethod = (payment) => {
  const paymentMethods = {
    [PAYMENT_TYPE.CASH]: formatCash,
    [PAYMENT_TYPE.COUNTERPARTY]: formatCounterparty,
    [PAYMENT_TYPE.LIQPAY_MERCHANT]: formatLiqPayMerchant,
    [PAYMENT_TYPE.PRIVATBANK_MERCHANT]: formatPrivatBankMerchant,
    [PAYMENT_TYPE.MONOBANK_MERCHANT]: formatMonobankMerchant,
    [PAYMENT_TYPE.MONOBANK_PAYPARTS]: formatMonobankPayParts,
  };

  function formatCash() {
    return _T("@Cash upon receipt");
  }

  function formatCounterparty(options) {
    return options.id.length === 8
      ? _T("@Cashless payment for legal")
      : _T("@Cashless payment for FOP");
  }

  function formatLiqPayMerchant(options) {
    return options.method === "payParts"
      ? _T("@Pay Parts")
      : options.method === "instantInstallment"
        ? _T("@Instant Installment")
        : _T("@Payment by card");
  }

  function formatPrivatBankMerchant(options) {
    return options.method === "payParts"
      ? _T("@Pay Parts")
      : _T("@Instant Installment");
  }

  function formatMonobankMerchant() {
    return _T("@Monobank payment");
  }

  function formatMonobankPayParts() {
    return _T("@Monobank payparts payment");
  }

  return paymentMethods[payment.type](payment.options);
};

export const getPayment = async (order) => {
  let payment = null;

  if (!isOrderPaid(order)) {
    const languageStore = useLanguageStore();
    const paymentUrl = `${useRuntimeConfig().public.apiBaseUrl}${languageStore.getUserLanguage.urlPrefix}/order/${order.id}?cashless=true`;

    if (PAYMENT_TYPE.LIQPAY_MERCHANT === order.payment.type) {
      await useAPI("/purchase/order/payment/driver/liqPay/merchant", {
        params: {
          orderId: order.id,
          redirectUrl: paymentUrl,
        },
      }).then((data) => {
        payment = {
          type: order.payment.type,
          ...data,
          redirectUrl: "https://www.liqpay.ua/api/3/checkout",
        };
      });
    }

    if (PAYMENT_TYPE.PRIVATBANK_MERCHANT === order.payment.type) {
      await useAPI("/purchase/order/payment/driver/privatBank/merchant", {
        params: {
          orderId: order.id,
          successRedirectUrl: paymentUrl,
          failRedirectUrl: paymentUrl,
        },
      }).then(({ url }) => {
        payment = {
          type: order.payment.type,
          redirectUrl: url,
        };
      });
    }

    if (PAYMENT_TYPE.MONOBANK_MERCHANT === order.payment.type) {
      await useAPI("/purchase/order/payment/driver/monobank/merchant", {
        params: {
          orderId: order.id,
          redirectUrl: paymentUrl,
        },
      }).then(({ url }) => {
        payment = {
          type: order.payment.type,
          redirectUrl: url,
        };
      });
    }

    if (PAYMENT_TYPE.MONOBANK_PAYPARTS === order.payment.type) {
      payment = {
        type: order.payment.type,
        orderId: order.id,
        phone: order.customer.phone,
      };
    }
  }

  return payment;
};
